import styled from "styled-components";

export const Description = styled.div`
    margin-top: 16px;
    margin-bottom: 16px;
`;
